import sha1 from 'sha1'
import axios from 'axios'
import store from '../store'
import { IRootStates } from '../models/store.model'

const url = process.env.REACT_APP_API_URL
const clientId = process.env.REACT_APP_API_CLIENT_ID
const clientSecret = process.env.REACT_APP_API_CLIENT_SECRET
const clientSha1 = sha1(`${clientId}:${clientSecret}`)
const Authorization = `Bearer ${clientSha1}`

export const APIServices = {
    authUrl: url,
    apiUrlV1: `${url}/v1`,
    clientId,
    axiosConfig: () => {
        const accessToken = `Bearer ${store?.getState()?.auth?.accessToken}`

        // config with axios global
        axios.defaults.baseURL = `${url}/v1`
        axios.defaults.headers.common.Authorization = accessToken
        axios.defaults.headers.common['Content-Type'] = 'application/json'
        axios.defaults.headers.post['Content-Type'] =
            'application/x-www-form-urlencoded'
    },

    // using this header to get authorization token
    authorizeHeader: () => {
        return {
            'Content-Type': 'application/json',
            Authorization,
        }
    },

    // using this header for login and register only
    authenticationHeader: () => {
        const token = store?.getState()?.auth?.authToken
        return {
            'Content-Type': 'application/json',
            token: `Bearer ${token}`,
        }
    },

    // using this header when user not yet authorize (not yet login)
    publicHeader: () => {
        const token = store?.getState()?.auth?.publicToken
        return {
            'Content-Type': 'application/json',
            token,
        }
    },

    // source
    axiosCancelToken: () => {
        return axios.CancelToken.source().cancel()
    },
}
